
export const APPLANCE_REQUEST="APPLANCE_REQUEST"
export const APPLANCE_SUCCESS="APPLANCE_SUCCESS"
export const APPLANCE_FAILURE="APPLANCE_FAILURE"
